import { on } from 'delegated-events';

import { bannersReload } from './banners-product-card';
import { findSiblings, isVisible, showLoader, hideLoader, conditionalContentSet } from '../utils/utils';

export default function () {
    function refreshTerms() {
        document.querySelectorAll('.detail-options dd').forEach(dd => {
            const item = dd.querySelector('li.selected');

            if (item) {
                item.parentElement.previousElementSibling.innerHTML = item.textContent;
            }
        });
    }

    function priceFormatter(value) {

        if (value)
            return value.toFixed(2).toString().replace('.', ',');
        return value;
    }

    function gatherAndSend(caller) {

        showLoader();

        const selectedFeatureArray = [];
        const scope = caller.closest('[data-scope="addcart"]');

        scope.querySelectorAll('dd ul').forEach(ul => {
            ul.querySelectorAll('li').forEach(li => {
                if (li.classList.contains('selected')) {
                    selectedFeatureArray.push(li.getAttribute('data-dictid'));
                }
            });
        });

        fetch('cartaction/FetchOptions', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({
                request: {
                    dicts: selectedFeatureArray,
                    pid: scope.querySelector('[data-pid]').getAttribute('data-pid')
                }
            }),
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            }
        })
            .then(response => response.json())
            .then(data => {

                const optionItem = scope.querySelector('[data-optionid]');

                if (data.OptionId) {
                    optionItem.setAttribute('data-optionid', data.OptionId);
                } else {
                    optionItem.setAttribute('data-optionid', -1);
                }

                if (data.ProductVariantUrl) {
                    window.history.pushState(null, null, data.ProductVariantUrl);
                }

                if (data.HtmlResponse) {
                    scope.querySelector('[data-role="option-view"]').innerHTML = data.HtmlResponse;
                }

                conditionalContentSet(document, '[data-role="sku"]', data.SKU);
                conditionalContentSet(document, '[data-role="ean"]', data.EAN);

                if (data.Prices) {
                    var pricesItem = data.Prices;

                    conditionalContentSet(scope, '[data-role="product-price"]', priceFormatter(pricesItem.PriceGross));

                    const omnibusPrice = scope.querySelector('[data-role="omnibus-lowest-price"]');
                    if (omnibusPrice) {
                        omnibusPrice.innerHTML = '';

                        if (pricesItem.OldPriceGross) {
                            omnibusPrice.innerHTML = pricesItem.OmnibusInfo;
                        }
                    }

                    conditionalContentSet(scope, '[data-role="product-discount-percentage"]', pricesItem.PercentDiscount);
                    conditionalContentSet(scope, '.promo-text', pricesItem.PercentDiscount);
                    conditionalContentSet(scope, '[data-role="product-oldprice"]', priceFormatter(pricesItem.OldPriceGross));
                }

                if (data.ProductState) {
                    const state = data.ProductState;
                    const availName = scope.querySelector('[data-role="avail-name"]');

                    if (availName) {
                        availName.innerHTML = state.Name;
                    }

                    conditionalContentSet(document, '[data-role="avail-desc"]', state.Description);
                    conditionalContentSet(document, '[data-role="avail-time"]', state.ShippingTime);
                }

                if (data.Images) {
                    bannersReload(data.Images);
                }

                const buyButton = scope.querySelector('.buy-button');

                if (data.CartEnabled) {
                    scope.classList.remove('cart-disabled');
                    buyButton.removeAttribute('disabled');
                } else {
                    scope.classList.add('cart-disabled');
                    buyButton.setAttribute('disabled', true);
                }

                refreshTerms();

                hideLoader();
            })
            .catch(error => {
                console.log(error);
                hideLoader();
            });
    }

    refreshTerms();

    // Wybór wariantu
    on('click', '.detail-options li:not(.selected)', function () {
        const liSiblings = findSiblings(this);

        liSiblings.forEach(li => li.classList.remove('selected'));
        this.classList.add('selected');

        gatherAndSend(this);
    });

    on('click', '.detail-options li.selected', function () {
        const list = document.querySelector('.detail-options dd.list-visible');

        if (list) {
            list.classList.remove('list-visible');
        }
    });

    // Pokazanie listy możliwych wariantów
    on('click', '.detail-options dd:not(.unactive) > span', function () {
        const optionList = this.parentElement.parentElement;
        const otherOptionsLists = findSiblings(optionList);

        otherOptionsLists.forEach(dl => dl.querySelectorAll('dd')[0].classList.remove('list-visible'));
        optionList.querySelectorAll('dd')[0].classList.toggle('list-visible');
    });

    document.addEventListener('mouseup', function (event) {
        const elements = document.querySelectorAll('.detail-options dd:not(.color)');

        elements.forEach(elem => {
            if (!elem.contains(event.target) && isVisible(elem)) {
                elem.classList.remove('list-visible');
            }
        });
    });
}